export enum NurseHomeTabID {
  SCHEDULE = 'schedule',
  MARKETPLACE = 'marketplace',
}
